import { Action } from "../actions/lifeActions"
import { PaginatedModel } from "interfaces/pagination"
import { Life } from "interfaces/life"
import { LifeActionType } from "state/action-types/lifeTypes"

const initialState: PaginatedModel<Life> = {
    paginatorInfo: {
        currentPage: 1,
        perPage: 30,
        lastPage: 1,
        total: 0
    },
    data: []
}

const reducer = (state: PaginatedModel<Life> = initialState, action: Action) => {
    switch (action.type) {
        case LifeActionType.PAGINATE_LIVES:
            return action.payload
        default:
            return state
    }
}

export default reducer